/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { TextField } from "@mui/material";
import { SettingsStyleEdit } from "cms/fields/layout/controls/settings-style";
import useStyles from "cms/fields/_styles";
import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import DisplaySettingsWrapper from "cms/fields/layout/display-settings-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
// import useThrottle from 'hooks/useThrottle'

const TextFieldItemEdit = () => {
    
    const { t } = useTranslation();
    // const throttler = useThrottle()
    const classes = useStyles();
    
    const ctx = useContext(ListItemContext);
    const { type, name, index, value, settings, updateListItem, disabled = false } = ctx;
    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { styleOptions, placeholder } = schemaSettings || {};
    
    const ph = placeholder || t("commons.placeholderText");
    
    const initialState = {
        value: value ? value : "",
        settings
    };
    const [itemLocalState, setItemLocalState] = useState(initialState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 1200),
        [updateListItem]
    );
    const onSettingsChange = (updateState) => {
        setItemLocalState(updateState);
        update(updateState, index);
    };
    const onChange = (event) => {
        const newValue = event.target.value;
        const newState = { ...itemLocalState, value: newValue };
        setItemLocalState(newState);
        update(newState, index);
    };
    
    return (
        <Fragment>
            {/*<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>*/}
            <div className='simplicity-composer-field-primary-layout'>
                
                <div className='simplicity-composer-field-primary'>
                    
                    <div className='simplicity-composer-helpful'>
                        <TextField
                            className={disabled ? classes.disabled : ""}
                            fullWidth={true}
                            placeholder={ph}
                            defaultValue={itemLocalState?.value}
                            disabled={disabled}
                            variant='standard'
                            onChange={onChange}
                        />
                        {/*<p>Value: {itemLocalState?.value}</p>*/}
                        {/*<p>Settings: {JSON.stringify(settings, null,2)}</p>*/}
                    </div>
                </div>
                {/*</Grid>*/}
                <DisplaySettingsWrapper>
                    {/*  Reads from schema options.styleOptions */}
                    {/*  records selection as value settings.style */}
                    <SettingsStyleEdit
                        type={type}
                        name={name}
                        label={t("commons.displayStyle")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        styleOptions={styleOptions}
                        selected={itemLocalState?.settings?.style}
                        index={index}
                        update={onSettingsChange}
                    />
                </DisplaySettingsWrapper>
            </div>
        </Fragment>
    );
};
export default TextFieldItemEdit;
